import { ChangeDetectionStrategy, Component, computed, OnInit, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BaseComponent } from '@core/base/base-component';

@Component({
  selector: 'app-no-account-page',
  imports: [RouterLink],
  templateUrl: './no-account-page.html',
  styleUrl: './no-account-page.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoAccountPage extends BaseComponent implements OnInit {
  readonly email = signal<string | null>(null);

  readonly message = computed(() => {
    const value = this.email();
    if (value) {
      return `We couldn't find an account for ${value}.`;
    }
    return "We couldn't find an account for that email.";
  });

  readonly signupQueryParams = computed(() => {
    const value = this.email();
    return value ? { email: value } : {};
  });

  readonly currentYear = new Date().getFullYear();

  ngOnInit(): void {
    this.email.set(this.route.snapshot.queryParamMap.get('email'));
  }
}
